import { render, staticRenderFns } from "./logoutUser.vue?vue&type=template&id=cb39dd90&scoped=true"
import script from "./logoutUser.vue?vue&type=script&lang=js"
export * from "./logoutUser.vue?vue&type=script&lang=js"
import style0 from "./logoutUser.vue?vue&type=style&index=0&id=cb39dd90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb39dd90",
  null
  
)

export default component.exports